import { useMutation, useQuery } from '@tanstack/react-query';
import { API_ENDPOINTS } from 'constants/endpoints';
import { get, handleError, handleResponse, del } from './base.service';

export const useGetChatUsersQuery = (params: string = '') =>
	useQuery({
		queryFn: async () => {
			try {
				const response = await get(`${API_ENDPOINTS.GET_CHAT_USERS}?${params}`);
				return handleResponse(response);
			} catch (err) {
				handleError(err);
			}
		},
		queryKey: ['get-chat-users'],
		refetchOnWindowFocus: false,
	});

export const useGetChatDetailsQuery = (data: any) =>
	useQuery({
		queryFn: async () => {
			try {
				const response = await get(`${API_ENDPOINTS.GET_CHAT_DETAILS}?${data?.params}`);
				return handleResponse(response);
			} catch (err) {
				handleError(err);
			}
		},
		queryKey: ['get-chat-details', data?.receiverId],
		refetchOnWindowFocus: false,
		enabled: !!data?.receiverId,
	});

export const useGetChatDetailsMutation = () =>
	useMutation({
		mutationFn: async (params: string) => {
			const response = await get(`${API_ENDPOINTS.GET_CHAT_DETAILS}?${params}`);
			return handleResponse(response);
		},
		onSuccess: handleResponse,
		onError: handleError,
	});

export const useDeleteChatRoomMutation = () =>
	useMutation({
		mutationFn: (id: number) => {
			return del(`${API_ENDPOINTS.GET_CHAT_USERS}/${id}`);
		},
		onSuccess: handleResponse,
		onError: handleError,
	});
